import { render, staticRenderFns } from "./CardDevelopment.vue?vue&type=template&id=5997022d"
import script from "./CardDevelopment.vue?vue&type=script&lang=js"
export * from "./CardDevelopment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports